import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { SharedDataService } from 'ngx-paf-common';
import { AuthState } from '../Models_Extranet/AuthState';
import { HttpRequest } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  constructor(
    public sharedSvc:SharedDataService,
    private oauthService:OAuthService
  ) { 
  }

  async UpdateGlobalClaims(): Promise<void> {
  const claims: any = this.oauthService.getIdentityClaims();
  if (!claims) throw new Error('No claims');
  if (this.sharedSvc.loggedId) return;

  return new Promise((resolve, reject) => {
    const sub = this.sharedSvc.loggedProfilChange.subscribe({
      next: (profil) => {
        sub.unsubscribe();
        profil ? resolve() : reject();
      },
      error: (err) => { sub.unsubscribe(); reject(err); }
    });
    this.sharedSvc.loggedId = claims['sub'];
  });
}

  getAccessToken():string{
    return this.oauthService.getAccessToken();
  }


  async CanActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return new Promise((resolve) => {
      if (!this.oauthService.hasValidAccessToken()) {
          const authState: AuthState = {
            url: route.url.toString(),
            baseApiUrl: this.sharedSvc.pafEnvironment.apiBaseUrl,
            clientUrl: window.location.origin,
            queryParams: Object.keys(route.queryParams).map((k: string) => ({
              Key: k, 
              Value: route.queryParams[k]
            }))
          };    
          const pafState: string = encodeURIComponent(JSON.stringify(authState));      
          this.oauthService.initLoginFlow(`?pafState=${pafState}`);
          resolve && resolve(false);
        } else {
          this.UpdateGlobalClaims().then(
            () => resolve && resolve(true),
            () => resolve && resolve(false)
          );
        }
    });
  }

  
  retrieveAuthenticationState(): string | undefined {
      return this.oauthService.hasValidAccessToken()
          ? decodeURIComponent(this.oauthService.state)
          : undefined;
  }

  async logout() {
    // Will redirect to Okta to end the session then redirect back to the configured `postLogoutRedirectUri`
    
    this.oauthService.revokeTokenAndLogout({
      client_id: this.oauthService.clientId,
      returnTo: this.oauthService.postLogoutRedirectUri
    }, true);    
  }

  addTokenToHeader(request: HttpRequest<unknown>): HttpRequest<unknown> {
      if (this.oauthService.hasValidAccessToken()) {
        let token = this.oauthService.getAccessToken();
        request = request.clone({
          headers: request.headers.set("Authorization", `Bearer ${token}`)
        });
      }
      request = request.clone({
        headers: request.headers.set("Paf-Language", `${this.sharedSvc.lngCod || 'FR'}`)
      });
      return request;
    }

}
